/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Agent_Access_TitleInputs */



/**
* | output |
* | --- |
* | "You can't run \"{name}\" yet. It uses things you don't have access to:" |
*
* @param {Agent_Access_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_title = /** @type {((inputs: Agent_Access_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Sie können „${i?.name}“ noch nicht ausführen. Der Agent nutzt Dinge, auf die Sie keinen Zugriff haben:`)
	return /** @type {LocalizedString} */ (`You can't run "${i?.name}" yet. It uses things you don't have access to:`)
});